<template>
  <div v-if="aberto" class="modal-overlay" @click.self="fechar">
    <div class="modal-container">
      <div class="modal-header">
        <h2>Análise do UID {{ uid }}</h2>
        <button class="btn-fechar" @click="fechar">&times;</button>
      </div>

      <div class="modal-body">
        <div v-if="loading" class="modal-loading">
          <span class="spinner"></span>
          <p>Carregando dados...</p>
        </div>

        <div v-else-if="loadFailed" class="modal-error">
          <p>Não foi possível carregar os dados.</p>
        </div>

        <div v-else-if="dados.length === 0" class="modal-empty">
          <p>Nenhum registro de qualidade de conexão encontrado para este UID.</p>
        </div>

        <div v-else class="modal-table-wrapper">
          <table class="modal-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Sala</th>
                <th>Data/Hora</th>
                <th>Bitrate (kbps)</th>
                <th>Frame Rate</th>
                <th>Perda de Pacotes (%)</th>
                <th>RTT (ms)</th>
                <th>Qualidade Upload</th>
                <th>Qualidade Download</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="registro in dados" :key="registro.sqc_id">
                <td>{{ registro.sqc_id }}</td>
                <td>{{ registro.sala_nome }}</td>
                <td>{{ formatarData(registro.sqc_created_at) }}</td>
                <td>{{ formatarBitrate(registro.sqc_send_bitrate) }}</td>
                <td>{{ registro.sqc_send_frame_rate || 'N/A' }}</td>
                <td>{{ formatarPercentual(registro.sqc_current_packet_loss_rate) }}</td>
                <td>{{ registro.sqc_send_rtt_ms || 'N/A' }}</td>
                <td>
                  <span 
                    class="qualidade-badge"
                    :class="getQualidadeClass(registro.sqc_uplink_network_quality)"
                  >
                    {{ getQualidadeTexto(registro.sqc_uplink_network_quality) }}
                  </span>
                </td>
                <td>
                  <span 
                    class="qualidade-badge"
                    :class="getQualidadeClass(registro.sqc_downlink_network_quality)"
                  >
                    {{ getQualidadeTexto(registro.sqc_downlink_network_quality) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import salasService from '../../service/salas.service';
import { showErrorToast } from '../../service/toast.service';

export default {
  name: 'ModalAnaliseUID',
  
  props: {
    aberto: {
      type: Boolean,
      required: true
    },
    uid: {
      type: String,
      default: ''
    },
    sala: {
      type: String,
      default: ''
    },
    tipo: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      loadFailed: false,
      dados: []
    };
  },

  watch: {
    aberto(novoValor) {
      if (novoValor && this.uid) {
        this.carregarDados();
      } else if (!novoValor) {
        this.limparDados();
      }
    }
  },

  methods: {
    async carregarDados() {
      this.loading = true;
      this.loadFailed = false;
      
      try {
        this.dados = await salasService.getInfoByUID(this.uid);
      } catch (err) {
        showErrorToast('Não foi possível carregar os dados deste UID.');
        this.loadFailed = true;
      } finally {
        this.loading = false;
      }
    },

    fechar() {
      this.$emit('fechar');
    },

    limparDados() {
      this.loading = false;
      this.loadFailed = false;
      this.dados = [];
    },

    formatarData(data) {
      if (!data) return 'N/A';
      const date = new Date(data);
      return date.toLocaleString('pt-BR');
    },

    formatarBitrate(bitrate) {
      if (!bitrate) return 'N/A';
      return Math.round(bitrate / 1000);
    },

    formatarPercentual(valor) {
      if (valor === null || valor === undefined) return 'N/A';
      return (valor * 100).toFixed(2);
    },

    getQualidadeTexto(qualidade) {
      const map = {
        0: 'Desconhecida',
        1: 'Excelente',
        2: 'Boa',
        3: 'Razoável',
        4: 'Ruim',
        5: 'Péssima',
        6: 'Sem Vídeo'
      };
      return map[qualidade] || 'N/A';
    },

    getQualidadeClass(qualidade) {
      const map = {
        0: 'qualidade-desconhecida',
        1: 'qualidade-excelente',
        2: 'qualidade-boa',
        3: 'qualidade-razoavel',
        4: 'qualidade-ruim',
        5: 'qualidade-pessima',
        6: 'qualidade-sem-video'
      };
      return map[qualidade] || '';
    }
  }
};
</script>

<style scoped src="./ModalAnaliseUID.css"></style>
